import { CardContentFragmentFragment } from '../../../__generated__/graphql';
import { Paragraph } from '../../../components/Text';

interface CardListProps {
  cardContent: CardContentFragmentFragment;
}

const CardList = ({
  cardContent,
}: CardListProps) => {
  if (!cardContent.list?.length) {
    return null;
  }

  return (
    <ul>
      {cardContent.list.map(item => {
        if (item) {
          return (
            <li key={item.item}>
              <Paragraph fontSize={15}>
                {item.item}
              </Paragraph>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default CardList;
